import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

export default lazyLoadOnRender({
  loader: () => import(/* webpackChunkName: "4-feat-teamssubheader" */ './TeamsSubHeader'),
});
